<template>
  <div class="contact-us-page">
    <div class="header-image">
      <img
        :src="require('@/assets/img/VM24_0994.jpg')"
        alt="Contact Porsche Auto Insurance"
      />
    </div>
    <section class="container">
      <h1 class="title ">Contact Us</h1>
      <div class="columns padding-needed">
        <div class="column is-two-thirds-desktop">
          <p>
            If you need Roadside Assistance, please call
            <a :href="'tel:1-' + roadsidePhoneNumber">{{
              roadsidePhoneNumber
            }}</a
            >. We are available 24/7.
          </p>
          <p>
            If you have been in an accident and need to speak to a claims
            concierge, please call us at
            <a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a
            >, ext. 3.
          </p>
          <p>
            For general questions or comments, please give us a call at
            <a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a
            >, ext. 2 or use the form below to send us an email. Please note
            that the more information you provide, the better we can serve you.
          </p>
        </div>
      </div>

      <form method="post" action="/" @submit.prevent="validateBeforeSubmit">
        <div class="columns padding-needed">
          <div class="column is-two-fifths-desktop">
            <fieldset>
              <legend for="subject" class="subtitle">Your Message</legend>

              <label
                :class="{
                  '-spacing-static-d': true,
                  error: errors.has('subject')
                }"
                >Subject *</label
              >
              <input
                :class="{
                  input__field: true,
                  error: errors.has('subject')
                }"
                name="subject"
                id="subject"
                type="text"
                v-validate="'required'"
                v-model="subject"
              />

              <label
                for="body"
                :class="{
                  '-spacing-static-d': true,
                  error: errors.has('body')
                }"
                >Body *</label
              >
              <textarea
                :class="{
                  input__field: true,
                  textarea__field: true,
                  error: errors.has('body')
                }"
                name="body"
                id="body"
                cols="41"
                rows="10"
                v-validate="'required'"
                v-model="body"
              ></textarea>
            </fieldset>

            <fieldset class="-spacing-static-d">
              <label class="subtitle" for="agree">Privacy Policy</label>
              <p>
                Porsche Auto Insurance or its agents may use the information you
                provide together with other information we have about you to
                contact you, including by mail, phone, SMS, fax or email, with
                offers or information about Porsche products and services we
                provide. We may keep your information for a reasonable period to
                contact you with offers, invitations or information about our
                products and services. For more information please reference our
                <router-link to="/legal/privacy-policy"
                  >Privacy Policy</router-link
                >.
              </p>
              <label
                ref="agreeCheckBox"
                :class="{
                  checkbox: true,
                  '-spacing-static-d': true,
                  error: errors.has('agree')
                }"
                style="display:block"
              >
                <input
                  class="checkbox__field"
                  type="checkbox"
                  id="agree"
                  name="agree"
                  value="1"
                  v-validate="'required'"
                  v-model="agree"
                />
                <span class="checkbox__icon icon icon--check"></span>
                <span class="checkbox__label"
                  >I have read and understood the Privacy Policy.</span
                >
              </label>
              <button
                type="submit"
                class="button-primary button-primary--black -spacing-static-f is-pulled-left"
              >
                <span class="button-primary__icon icon icon--arrow-right-hair">
                  <span class="loader-base button-primary__loader"></span>
                </span>

                <span class="button button-primary__label">Send</span>
              </button>
            </fieldset>
          </div>

          <div class="column is-two-fifths-desktop is-offset-one-fifth-desktop">
            <fieldset>
              <legend for="first_name" class="subtitle">
                Personal Details
              </legend>

              <div class="columns">
                <div class="column is-half">
                  <label
                    :class="{
                      '-spacing-static-d': true,
                      error: errors.has('first_name')
                    }"
                    >First Name *</label
                  >
                  <input
                    :class="{
                      input__field: true,
                      error: errors.has('first_name')
                    }"
                    name="first_name"
                    type="text"
                    v-validate="'required|alpha'"
                    maxlength="63"
                    v-model="firstName"
                  />
                </div>

                <div class="column is-half">
                  <label for="middle_initial" class="-spacing-static-d"
                    >Middle Initial</label
                  >
                  <input
                    id="middle_initial"
                    :class="{
                      input__field: true,
                      error: errors.has('middle_initial')
                    }"
                    name="middle_initial"
                    type="text"
                    maxlength="63"
                    v-model="middleInitial"
                  />
                </div>
              </div>

              <div class="columns">
                <div class="column is-half">
                  <label
                    :class="{
                      '-spacing-static-d': true,
                      error: errors.has('last_name')
                    }"
                    >Last Name *</label
                  >
                  <input
                    :class="{
                      input__field: true,
                      error: errors.has('last_name')
                    }"
                    name="last_name"
                    type="text"
                    v-validate="'required|alpha'"
                    maxlength="63"
                    v-model="lastName"
                  />
                </div>

                <div class="column is-one-quarter">
                  <label for="suffix" class="-spacing-static-d">Suffix</label>
                  <input
                    id="suffix"
                    class="input__field"
                    name="suffix"
                    type="text"
                    v-model="suffix"
                  />
                </div>
              </div>

              <label
                :class="{
                  '-spacing-static-d': true,
                  error: errors.has('email')
                }"
                >Email *</label
              >
              <input
                :class="{
                  input__field: true,
                  error: errors.has('email')
                }"
                name="email"
                id="email"
                type="email"
                v-validate="'required|email'"
                v-model="email"
                data-vv-validate-on="blur"
              />
              <div v-show="errors.has('email')" class="help error-text">
                Please enter a valid email address.
              </div>

              <label
                for="telephoneNumber"
                :class="{
                  '-spacing-static-d': true,
                  error: errors.has('telephoneNumber')
                }"
                >Telephone Number (000-000-0000)</label
              >
              <cleave
                :class="{
                  input__field: true,
                  error: errors.has('telephoneNumber')
                }"
                id="telephoneNumber"
                name="telephoneNumber"
                v-model="telephoneNumber"
                :options="validationOptions.phoneNumber"
                placeholder="Telephone Number (000-000-0000)"
                v-validate="'phoneNumber'"
                data-vv-validate-on="blur"
              ></cleave>
            </fieldset>

            <p class="-spacing-static-f">* Mandatory fields</p>

            <fieldset>
              <label
                ref="agreeCheckBox"
                :class="{
                  checkbox: true,
                  '-spacing-static-d': true,
                  error: errors.has('transactionalOptin')
                }"
                style="display:block"
              >
                <input
                  class="checkbox__field"
                  type="checkbox"
                  id="transactionalOptin"
                  name="transactionalOptin"
                  value="1"
                  v-validate="'required'"
                  v-model="transactionalOptin"
                />
                <span class="checkbox__icon icon icon--check"></span>
                <span class="checkbox__label"
                  >I consent to receive non-marketing text messages from Porsche
                  Auto Insurance regarding policy servicing, billing, claims,
                  and general policy management. Frequency may vary. Message &
                  data rates may apply. You may reply STOP to opt out at any
                  time.</span
                >
              </label>
            </fieldset>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'ContactUs',
  data: () => ({
    roadsidePhoneNumber: '866-599-8238',
    subject: '',
    body: '',
    agree: '',
    firstName: '',
    middleInitial: '',
    lastName: '',
    suffix: '',
    email: '',
    telephoneNumber: '',
    transactionalOptin: false,
    predefinedSubject: process.env.VUE_APP_MANDRILL_EMAIL_SUBJECT,
    fakefromEmailAddress: process.env.VUE_APP_MANDRILL_FAKE_FROM_EMAIL,
    toEmailAddress: process.env.VUE_APP_MANDRILL_TO_EMAIL,
    toName: process.env.VUE_APP_MANDRILL_TO_NAME,
    validationOptions: {
      phoneNumber: {
        phone: true,
        phoneRegionCode: 'US',
        delimiter: '-'
      }
    }
  }),
  methods: {
    ...mapActions(['contactFormSubmit']),
    ...mapMutations(['toggleLoader']),
    submitForm() {
      const contactUsFormData = {
        customSubject: this.subject || this.predefinedSubject,
        emailBody: this.body,
        userEmailAddress: this.email,
        userSuffixName: this.suffix,
        userFirstName: this.firstName,
        userLastName: this.lastName,
        userMiddleName: this.middleInitial,
        userPhoneNumber: this.telephoneNumber
      };
      this.toggleLoader({
        loaderText: 'Loading...'
      });
      this.contactFormSubmit(contactUsFormData)
        .then(() => {
          this.toggleLoader();
          this.$snackbar.open({
            type: 'is-success',
            message: `Thank you for contacting Porsche Auto Insurance. A customer care concierge will be in touch as soon as possible`,
            position: 'is-bottom',
            duration: 10000
          });
          this.$router.push({ path: '/' });
        })
        .catch(err => {
          this.toggleLoader();
          let message =
            err.msg || 'Something went wrong. Please try again later.';
          let toastType = 'is-danger';
          this.$snackbar.open({
            type: toastType,
            message: message,
            position: 'is-bottom'
          });
        });
    },
    validateBeforeSubmit() {
      event.preventDefault();
      let firstErrorField;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.submitForm();
          return;
        }
        if (this.$validator.errors.items[0].field === 'agree') {
          this.$refs.agreeCheckBox.scrollIntoView();
        } else {
          firstErrorField = this.$el.querySelector(
            '[name="' + this.$validator.errors.items[0].field + '"]'
          );
          firstErrorField.focus();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
label.checkbox {
  display: flex;
}
.title {
  text-align: center;
}
.header-image {
  max-height: 100vh;
  overflow: clip;

  img {
    display: block;
    margin: 0;
    max-width: 100%;
    padding: 0;
  }
}

.contact-us-page {
  .section {
    img {
      object-position: 65% 66% !important;
    }
  }
}

.input__field,
.textarea__field {
  padding: 0.8025rem 1rem !important;
  font-size: 1rem;
  max-height: unset;
}

.container {
  margin-bottom: 4rem;
  padding-bottom: 4rem;
  padding-top: 5rem;
}

.padding-needed {
  padding: 0 2%;
  @media (max-width: 769px) {
    padding: 0;
  }
}
.columns {
  .columns {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.column {
  .column {
    padding-top: 0;
    padding-bottom: 0;
  }
}

label {
  display: inline-block;
}

.subtitle {
  font-family: $family-sans-serif-thin;
  font-size: 20px;
  margin-bottom: 0.25rem;
}

.button-primary {
  float: right;
}
</style>
